import './MobileSkeletonLoading.scss';

/**
 * Mobile skeleton card component for loading state
 * Mirrors the actual RequestCard layout:
 * - Left colored border
 * - Avatar circle with initials
 * - Date/time and action icon row
 * - Title row
 * - Description row with optional amount
 */
const MobileSkeletonCard = () => (
  <div className="ksq2-mobile-skeleton__card">
    <div className="ksq2-mobile-skeleton__card-border" />
    <div className="ksq2-mobile-skeleton__avatar" />
    <div className="ksq2-mobile-skeleton__content">
      <div className="ksq2-mobile-skeleton__top-row">
        <div className="ksq2-mobile-skeleton__date" />
        <div className="ksq2-mobile-skeleton__action-icon" />
      </div>
      <div className="ksq2-mobile-skeleton__title" />
      <div className="ksq2-mobile-skeleton__bottom-row">
        <div className="ksq2-mobile-skeleton__description" />
        <div className="ksq2-mobile-skeleton__amount" />
      </div>
    </div>
  </div>
);

/**
 * Mobile skeleton group header
 */
const MobileSkeletonGroupHeader = () => (
  <div className="ksq2-mobile-skeleton__group-header">
    <div className="ksq2-mobile-skeleton__group-label" />
    <div className="ksq2-mobile-skeleton__group-count" />
    <div className="ksq2-mobile-skeleton__group-chevron" />
  </div>
);

interface MobileSkeletonLoadingProps {
  /** Number of skeleton cards to show. Defaults to 5, max 15 */
  count?: number;
}

/**
 * Mobile skeleton loading state component for MobileRequestList
 * Shows placeholder cards while data is being fetched
 */
export const MobileSkeletonLoading = ({ count = 5 }: MobileSkeletonLoadingProps) => {
  const cardCount = Math.min(Math.max(count, 1), 15);

  return (
    <div className="ksq2-mobile-skeleton">
      {/* First group - "This Week" style */}
      <MobileSkeletonGroupHeader />
      <div className="ksq2-mobile-skeleton__group">
        <MobileSkeletonCard />
      </div>

      {/* Second group - "Last Week" style */}
      {cardCount > 1 && (
        <>
          <MobileSkeletonGroupHeader />
          <div className="ksq2-mobile-skeleton__group">
            <MobileSkeletonCard />
          </div>
        </>
      )}

      {/* Third group - "Last Month" or similar */}
      {cardCount > 2 && (
        <>
          <MobileSkeletonGroupHeader />
          <div className="ksq2-mobile-skeleton__group">
            {Array.from({ length: Math.min(cardCount - 2, 3) }).map((_, i) => (
              <MobileSkeletonCard key={`group3-${i}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MobileSkeletonLoading;
